import axios from 'axios';



// API基础URL - 自动处理/api后缀

// 本地测试使用新系统 server: 127.0.0.1:4100，生产环境默认使用当前域名

const BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? window.location.origin : 'http://127.0.0.1:4100');

const API_URL = BASE_URL.endsWith('/api/v2')

  ? BASE_URL

  : BASE_URL.endsWith('/api')

    ? `${BASE_URL}/v2`

    : `${BASE_URL}/api/v2`;



console.log('🔧 API配置:', {

  BASE_URL,

  API_URL,

  mode: process.env.NODE_ENV

});



// 创建API实例

const api = axios.create({

  baseURL: API_URL,

  headers: {

    'Content-Type': 'application/json'

  }

});



// 请求拦截器：添加认证token

api.interceptors.request.use(

  (config) => {

    const token = localStorage.getItem('token');

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



// 响应拦截器：处理错误

api.interceptors.response.use(

  (response) => response,

  (error) => {

    // 处理401未授权（未登录或token过期）

    if (error.response && error.response.status === 401 && !error.config?.skipLoginRedirect) {

      localStorage.removeItem('token');

      localStorage.removeItem('user');

      window.location.href = '/login';

    }

    return Promise.reject(error);

  }

);



// 身份认证相关API

export const authAPI = {

  login: (credentials) => api.post('/auth/login', credentials),

  register: (data) => api.post('/auth/register', data),

  profile: () => api.get('/auth/profile'),

  updateProfile: (data) => api.put('/auth/profile', data),

  changePassword: (currentPassword, newPassword) => api.put('/auth/password', {

    currentPassword,

    newPassword

  })

};



// 学校相关API

export const schoolAPI = {

  // 基础CRUD

  getAll: (params) => api.get('/schools', { params }),

  getList: () => api.get('/schools/list'),

  getGeoStats: () => api.get('/schools/geo/stats'),

  getById: (id) => api.get(`/schools/${id}`),

  create: (data) => api.post('/schools', data),

  update: (id, data) => api.put(`/schools/${id}`, data),

  delete: (id) => api.delete(`/schools/${id}`),



  // 统计与子资源

  getStats: (id) => api.get(`/schools/${id}/stats`),

  getClasses: (id) => api.get(`/schools/${id}/classes`),

  getTeachers: (id) => api.get(`/schools/${id}/teachers`),



  // 状态管理（启用/停用/试用/到期）

  toggleStatus: (id, status, expire_date) =>

    api.patch(`/schools/${id}/status`, { status, expire_date }),



  // 模块权限管理

  getModules: (id) => api.get(`/schools/${id}/modules`),

  updateModule: (id, moduleCode, data) =>

    api.put(`/schools/${id}/modules/${moduleCode}`, data),

  batchUpdateModules: (id, modules) =>

    api.put(`/schools/${id}/modules`, { modules }),



  // 操作审计日志

  getOperationLogs: (id, params) =>

    api.get(`/schools/${id}/logs`, { params }),



  // 系统模块定义（超级管理员使用）

  getModuleDefinitions: () => api.get('/schools/modules/definitions'),

  updateModuleDefinition: (code, data) =>

    api.put(`/schools/modules/definitions/${code}`, data),

};



export const officialSchoolAPI = {

  getProvinces: () => api.get('/official-schools/provinces'),

  getCities: (provinceCode) => api.get('/official-schools/cities', { params: { provinceCode } }),

  getCounties: (cityCode) => api.get('/official-schools/counties', { params: { cityCode } }),

  getCategories: (countyCode) => api.get('/official-schools/categories', { params: { countyCode } }),

  getSchools: (params) => api.get('/official-schools', { params }),

  getByCode: (officialSchoolCode) => api.get(`/official-schools/${officialSchoolCode}`)

};



// 管理员相关API

export const schoolAffiliationCorrectionAPI = {

  submit: (data) => api.post('/school-affiliation-corrections', data),

  joinByCode: (data) => api.post('/school-affiliation-corrections/join-by-code', data),

  joinOfficialSchool: (officialSchoolCode, options = {}) => api.post('/school-affiliation-corrections/join-by-code', {

    official_school_code: officialSchoolCode,

    migration_mode: options.migrationMode || options.migration_mode || 'none',

    class_ids: options.classIds || options.class_ids || []

  }),

  getOfficialMigrationPreview: (officialSchoolCode) => api.get('/school-affiliation-corrections/official-migration-preview', {

    params: { officialSchoolCode }

  }),

  getMyList: (params) => api.get('/school-affiliation-corrections/my', { params }),

  cancel: (id) => api.patch(`/school-affiliation-corrections/${id}/cancel`),

  getAll: (params) => api.get('/school-affiliation-corrections', { params }),

  getMigrationPreview: (id) => api.get(`/school-affiliation-corrections/${id}/migration-preview`),

  review: (id, data) => api.put(`/school-affiliation-corrections/${id}/review`, data),

  revoke: (id, data) => api.patch(`/school-affiliation-corrections/${id}/revoke`, data),

};



export const teacherNavigationReviewAPI = {

  getSubmissions: (params) => api.get('/teacher-navigation/admin/submissions', { params }),

  review: (id, data) => api.put(`/teacher-navigation/admin/submissions/${id}/review`, data)

};



export const teacherResourceAPI = {

  getAll: (params) => api.get('/teacher-navigation/admin/resources', { params }),

  create: (data) => api.post('/teacher-navigation/admin/resources', data),

  update: (id, data) => api.put(`/teacher-navigation/admin/resources/${id}`, data)

};



export const adminAPI = {

  getAll: () => api.get('/admins'),

  getById: (id) => api.get(`/admins/${id}`),

  create: (data) => api.post('/admins', data),

  update: (id, data) => api.put(`/admins/${id}`, data),

  delete: (id) => api.delete(`/admins/${id}`),

  resetPassword: (id, password) => api.put(`/admins/${id}/reset-password`, { password }),

  toggleStatus: (id, status) => api.put(`/admins/${id}/status`, { status })

};



// 教师相关API

export const teacherAPI = {

  getAll: (params) => api.get('/teachers', { params }),

  getById: (id) => api.get(`/teachers/${id}`),

  create: (data) => api.post('/teachers', data),

  update: (id, data) => api.put(`/teachers/${id}`, data),

  delete: (id) => api.delete(`/teachers/${id}`),

  resetToken: (id) => api.put(`/teachers/${id}/token`, {}),

  setToken: (id, token) => api.put(`/teachers/${id}/token`, { token }),

  resetPassword: (id, newPassword) => api.put(`/teachers/${id}/reset-password`, { newPassword }),

  toggleStatus: (id, status) => api.put(`/teachers/${id}/status`, { status })

};



// 学生相关API

export const studentAPI = {

  getAll: (params) => {

    console.log('studentAPI.getAll 调用，参数:', params);

    

    // 确保参数是一个对象

    const queryParams = params || {};

    

    return api.get('/students', { 

      params: queryParams,

      // 增加错误处理和超时设置

      timeout: 10000,

      validateStatus: function (status) {

        return status >= 200 && status < 300; // 默认情况

      }

    }).then(response => {

      console.log('studentAPI.getAll 响应:', response.data);

      return response;

    }).catch(error => {

      console.error('studentAPI.getAll 错误:', error);

      throw error;

    });

  },

  getById: (id) => api.get(`/students/${id}`),

  create: (data) => api.post('/students', data),

  update: (id, data) => api.put(`/students/${id}`, data),

  delete: (id) => api.delete(`/students/${id}`),

  batchDelete: (data) => api.post('/students/batch-delete', data),

  getImportTemplate: () => api.get('/students/import-template', { 

    responseType: 'blob',

    headers: {

      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream'

    },

    timeout: 30000

  }),

  importStudents: (formData) => api.post('/students/import', formData, {

    headers: {

      'Content-Type': 'multipart/form-data'

    }

  })

};



// 班级相关API

export const classAPI = {

  getAll: (params) => api.get('/classes', { params }),

  getById: (id) => api.get(`/classes/${id}`),

  create: (data) => api.post('/classes', data),

  update: (id, data) => api.put(`/classes/${id}`, data),

  delete: (id) => api.delete(`/classes/${id}`),

  resetToken: (id) => api.put(`/classes/${id}/token`, {}),

  setToken: (id, token) => api.put(`/classes/${id}/token`, { token }),

  toggleStatus: (id, status) => api.put(`/classes/${id}/status`, { status })

};



export const classTodoAPI = {

  getByClass: (classId) => api.get(`/class-todos/class/${classId}`),

  getManageList: (classId) => api.get(`/class-todos/class/${classId}/all`),

  create: (classId, data) => api.post(`/class-todos/class/${classId}`, data),

  update: (id, data) => api.put(`/class-todos/${id}`, data),

  updateStatus: (id, status) => api.put(`/class-todos/${id}/status`, { status }),

  delete: (id) => api.delete(`/class-todos/${id}`)

};



// 创建广播相关的API

export const broadcastAPI = {

  // 获取仪表盘数据

  getDashboardData: () => {

    return api.get('/broadcasts/dashboard');

  },



  // 系统管理员新版仪表盘：固定窗口读取最近人工/即时广播，不统计定期广播

  getRecentManualMessages: () => {

    return api.get('/broadcasts/recent-manual');

  },

  

  // 发送广播消息

  sendMessage: (messageData) => {

    return api.post('/broadcasts/send', messageData);

  },

  

  // 获取消息历史

  getMessageHistory: (filters = {}) => {

    return api.get('/broadcasts/history', {

      params: filters

    });

  },

  

  // 获取班级的消息历史

  getClassHistory: (classId) => {

    return api.get(`/broadcasts/history/${classId}`);

  },

  

  // 上传文件

  uploadFile: (formData) => {

    return api.post('/upload', formData, {

      headers: {

        'Content-Type': 'multipart/form-data'

      }

    }).then((response) => {

      const uploaded = response.data?.data;

      const url = uploaded?.url || response.data?.files?.[0]?.url;

      if (url) response.data.filePath = new URL(url, API_URL).href;

      return response;

    });

  },

  

  // 删除广播消息

  deleteMessage: (messageId) => {

    return api.delete(`/broadcasts/message/${messageId}`);

  },

  

  // 获取所有消息发送者

  getSenders: () => {

    return api.get('/broadcasts/senders');

  },



  // ========== 定时广播相关API ==========

  

  // 创建定时广播

  createScheduledBroadcast: (data) => {

    return api.post('/scheduled-broadcasts', data);

  },

  

  // 获取定时广播列表

  getScheduledBroadcasts: (params = {}) => {

    return api.get('/scheduled-broadcasts', { params });

  },

  

  // 获取定时广播详情

  getScheduledBroadcastDetail: (id) => {

    return api.get(`/scheduled-broadcasts/${id}`);

  },

  

  // 暂停/恢复定时广播

  toggleScheduledBroadcast: (id) => {

    return api.put(`/scheduled-broadcasts/${id}/toggle`);

  },

  

  // 删除定时广播

  deleteScheduledBroadcast: (id) => {

    return api.delete(`/scheduled-broadcasts/${id}`);

  },

  

  // 获取定时广播执行日志

  getScheduledBroadcastLogs: (id) => {

    return api.get(`/scheduled-broadcasts/${id}/logs`);

  },

  

  // 获取调度器状态

  getSchedulerStatus: () => {

    return api.get('/scheduled-broadcasts/status');

  }

};



// 系统设置相关API

export const notificationAPI = {

  getUnread: () => api.get('/notifications/unread'),

  markRead: (id) => api.put(`/notifications/${id}/read`, {}),

  markAllRead: () => api.put('/notifications/read-all', {}),

  listAnnouncements: (params = {}) => api.get('/notifications/announcements', { params }),

  publishAnnouncement: (data) => api.post('/notifications/announcements', data)

};



export const systemSettingsAPI = {

  getAll: () => api.get('/system-settings'),

  getByKey: (key) => api.get(`/system-settings/${key}`),

  update: (key, value) => api.put(`/system-settings/${key}`, { value }),

  batchUpdate: (settings) => api.post('/system-settings/batch-update', settings)

};



export const systemMonitorAPI = {

  getOverview: () => api.get('/system-monitor/overview')

};



export const systemAdminDashboardV3API = {

  getOverview: () => api.get('/system-admin-dashboard-v3/overview')

};



// 邀请码相关API

export const invitationCodeAPI = {

  getAll: (params) => api.get('/invitation-codes', { params }),

  getById: (id) => api.get(`/invitation-codes/${id}`),

  create: (data) => api.post('/invitation-codes', data),

  verify: (code) => api.get(`/invitation-codes/verify/${code}`),

  disable: (id) => api.put(`/invitation-codes/${id}/disable`),

  enable: (id) => api.put(`/invitation-codes/${id}/enable`),

  delete: (id) => api.delete(`/invitation-codes/${id}`)

};



// 班级邀请相关API

export const classInvitationAPI = {

  generate: (data) => api.post('/class-invitations', data),

  join: (invitationCode) => api.post('/class-invitations/join', { invitation_code: invitationCode }),

  getByClass: (classId) => api.get(`/class-invitations/class/${classId}`),

  revoke: (id) => api.delete(`/class-invitations/${id}`)

};



export const classJoinQrcodeAPI = {

  create: (data) => api.post('/class-join-qrcodes', data),

  getByClass: (classId) => api.get(`/class-join-qrcodes/class/${classId}`),

  verify: (code) => api.get(`/class-join-qrcodes/verify/${code}`),

  join: (code) => api.post('/class-join-qrcodes/join', { code }),

  disable: (id) => api.delete(`/class-join-qrcodes/${id}`)

};



export const schoolAdminAPI = {
  getReadingHistory: (params) => api.get('/school-admin/reading-history', { params }),

  getSchools: (params) => api.get('/school-admin/schools', { params }),

  getOverview: (params) => api.get('/school-admin/overview', { params }),

  getWorkbench: (params) => api.get('/school-admin/workbench', { params }),

  getGrades: (params) => api.get('/school-admin/grades', { params }),

  getTeachers: (params) => api.get('/school-admin/teachers', { params }),

  importTeacherInvitations: (data) => api.post('/school-admin/teachers/import-invitations', data),

  removeTeacher: (accountId, params) => api.delete(`/school-admin/teachers/${accountId}`, { params }),

  getJoinPassword: (params) => api.get('/school-admin/join-password', { params }),

  setJoinPassword: (data) => api.put('/school-admin/join-password', data),

  disableJoinPassword: (params) => api.delete('/school-admin/join-password', { params }),

  getDevices: (params) => api.get('/school-admin/devices', { params }),

  generateSchoolClassQrcodes: (data) => api.post('/school-admin/class-qrcodes/generate', data),

  sendDeviceBatchCommand: (data) => api.post('/devices/batch-command', data)

};



export const schoolAdministrationAPI = {

  get: schoolId => api.get(`/school-administration/schools/${schoolId}`),

  setAccess: (schoolId,data) => api.put(`/school-administration/schools/${schoolId}/access`,data),

  invite: (schoolId,data) => api.post(`/school-administration/schools/${schoolId}/invitations`,data),

  reinvite: (schoolId,grantId) => api.post(`/school-administration/schools/${schoolId}/grants/${grantId}/invitation`),

  renew: (schoolId,grantId,data) => api.put(`/school-administration/schools/${schoolId}/grants/${grantId}`,data),

  revoke: (schoolId,grantId) => api.delete(`/school-administration/schools/${schoolId}/grants/${grantId}`),

  upload: (schoolId,data) => api.post(`/school-administration/schools/${schoolId}/verification-files`,data,{ headers: { 'Content-Type': 'multipart/form-data' } }),

  file: (schoolId,fileId) => api.get(`/school-administration/schools/${schoolId}/verification-files/${fileId}`,{ responseType: 'blob' }),

  preview: token => api.post('/school-administration/activation/preview',{ token }),

  activate: data => api.post('/school-administration/activation',data,{ skipLoginRedirect: true })

};



export const gradeManagementAPI = {

  context: (params) => api.get('/grade-management/context', { params }),

  assignments: (params) => api.get('/grade-management/assignments', { params }),

  grant: (data) => api.post('/grade-management/assignments', data),

  revoke: (id, params) => api.delete(`/grade-management/assignments/${id}`, { params }),

  data: (params) => api.get('/grade-management/data', { params }),

  update: (type, id, data) => api.put(`/grade-management/data/${type}/${id}`, data)

};



export default api;

